import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import SelectFieldSection from "./SelectFieldSection";
import SelectFieldSectionMobile from "./SelectFieldSectionMobile";

const TemplatesSection = () => {
  const text = "Explore pre-built WhatsApp templates for every business scenario";
  const text1 = "WhatsApp templates for use";
  const subtitle1 =
    "Use WhatsApp templates to easily share updates and talk with customers better.";

  const colors = ["#1a1aff", "#7a00cc", "#2e5cb8", "#666699", "#9900e6"];
  const [colorIndex, setColorIndex] = useState(0);

  return (
    <Stack
      sx={{
        height: "auto",
        padding: { xs: "30px 15px", sm: "40px 20px", md: "60px 30px" },
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#dae9f8",
        display: { xl: "flex", lg: "flex", md: "flex", sm: "flex", xs: "none" },
      }}
    >
      {/* Main Heading */}
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          width: { xl: "74%", lg: "92%", md: "94%" },
          gap: 1,
        }}
      >
        <Stack
          sx={{
            // border: "1px solid red",
            fontSize: {
              xs: "22px",
              sm: "26px",
              md: "30px",
              lg: "34px",
            },
            color: "#054E91",
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 600,
            letterSpacing: "0.5px",
            textAlign: "left",
            fontWeight: { xs: 600, sm: 600, md: 600, lg: 600, xl: 600 },
            marginBottom: "12px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                width: { xl: "6px", lg: "6px", xs: "4px" },
                height: { xs: "22px", sm: "36px", md: "30px" },
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: "rgb(5 78 146)",
                marginRight: {
                  xs: "8px",
                  sm: "8px",
                  md: "12px",
                  lg: "12px",
                  xl: "12px",
                },
                borderTopRightRadius: "8px",
                borderBottomRightRadius: "8px",
              }}
            >
              <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
            </Stack>
          </Stack>
          <Stack
            sx={{
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "none",
              },
              color: "rgb(5 78 146)",
            }}
          >
            {text}
          </Stack>
          <Stack
            sx={{
              display: {
                xl: "none",
                lg: "none",
                md: "none",
                sm: "none",
                xs: "flex",
              },
              color: "rgb(5 78 146)",
            }}
          >
            {text1}
          </Stack>
        </Stack>

        {/* Subtitle: Multiline for large screens */}
        <Stack
          sx={{
            width: "100%",
            fontSize: {
              xs: "15px",
              sm: "17px",
              md: "20px",
            },
            lineHeight: { xs: 1.5, sm: 1.80, md: 1.2 },
            fontFamily: "'Roboto', sans-serif",
            color: "text.secondary",
            textAlign: "left",
            border: "1px solid white",
            backgroundColor: "#fff",
            // padding: "20px",
            padding: 1,
            borderRadius: "8px",
            display: {
              xl: "flex",
              lg: "flex",
              md: "flex",
              sm: "flex",
              xs: "none",
            },
          }}
        >
          <span>
            Boost customer engagement with interactive, pre-approved WhatsApp templates.
            Effortlessly deliver updates, highlight products and collect valuable feedback.
            Using personalized WhatsApp templates enables your business to connect, communicate and convert more customers consistently.
          </span>

        </Stack>


        {/* Subtitle for mobile (single line) */}
        <Stack
          sx={{
            fontSize: {
              xs: "20px",
              sm: "16px",
              md: "16px",
              lg: "24px",
              xl: "24px",
            },
            fontWeight: 400,
            lineHeight: {
              xs: "20px",
              sm: "22px",
              md: "32px",
              lg: "32px",
              xl: "32px",
            },
            color: "text.secondary",
            maxWidth: { xs: "100%", sm: "80%", md: "100%" },
            mb: { xs: "20px", md: "40px", lg: "0px", xl: "0px", sm: "0px" },
            fontFamily: "'Roboto', sans-serif",
            border: "1px solid rgb(218 233 248)",
            backgroundColor: "rgb(218 233 248)",
            padding: "8px",
            borderRadius: "8px",
            display: {
              xl: "none",
              lg: "none",
              md: "none",
              sm: "none",
              xs: "flex",
            },
          }}
        >
          {subtitle1}
        </Stack>
      </Stack>

      {/* Desktop field section */}
      <Stack
        sx={{
          // border: "1px solid red",
          display: {
            xl: "flex",
            lg: "flex",
            md: "flex",
            sm: "flex",
            xs: "none",
          },
          flexDirection: "row",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <SelectFieldSection />
      </Stack>

      {/* Mobile field section */}
      <Stack
        sx={{
          display: {
            xl: "none",
            lg: "none",
            md: "none",
            sm: "none",
            xs: "flex",
          },
          flexDirection: "row",
          width: "100%",
        }}
      >
        <SelectFieldSectionMobile />
      </Stack>
    </Stack>
  );
};

export default TemplatesSection;
